import { type FeatureFlagNames } from 'api/configuration/features/FeatureFlagConfigurationSetting';

import { useHasFeatureFlag } from './useHasFeatureFlag';

/**
 * Return true if the feature flag is enabled for the current user.
 */
export const useFeatureFlag = (name: FeatureFlagNames) => {
  const hasFeatureFlag = useHasFeatureFlag();

  return hasFeatureFlag(name);
};
